import { ActionButton } from '@elotech/components';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';

type Props = {
  header: string;
  buttonHint: string;
  icon: IconProp;
  onClick: (event: React.MouseEvent) => void;
};

const ButtonHeader: React.FC<Props> = ({
  header,
  buttonHint,
  icon,
  onClick
}) => (
  <div
    className="hidden-xs"
    style={{
      display: 'flex',
      alignItems: 'left'
    }}
  >
    {header}
    <div
      style={{
        margin: '-6px 0px'
      }}
    >
      <ActionButton
        data-testid="showAllButton"
        icon={icon}
        label={buttonHint}
        key="showAllButton"
        onClick={(event: React.MouseEvent) => {
          event.stopPropagation();
          onClick(event);
        }}
      />
    </div>
  </div>
);

export { ButtonHeader };
